"use client"

import LinkAsButton from "@/components/buttons/LinkAsButton"
import GetAppButtons from "@/components/GetAppButtons"
import { GenericSection } from "@/components/sections"
import { BodyDefaultLight, BodySmall, Heading2 } from "@/components/text"
import Modal from "../../modal/Modal"

export default function DonateWithGiftCard() {
  return (
    <GenericSection
      headerSubtitle={<BodySmall className="text-red mb-[0.75rem] md:mb-[1rem]">GoodShift Giftcard</BodySmall>}
      header={{
        text: "Doneer met je giftcard",
        type: "h2",
      }}
      content={
        <>
          <BodyDefaultLight>
            Heb je een giftcard gekregen? Via de app kun je jouw giftcard gebruiken om te doneren aan jouw favoriete
            goede doel. 
          </BodyDefaultLight>

          <Modal
            type="secondary"
            buttonText="Download de app"
            title="Download de app"
            description={<GetAppButtons />}
            footer={undefined}
          />

          <Heading2 className="mt-14 md:mt-14 mb-8 md:mb-8">Ben je een bedrijf of vereniging?</Heading2>

          <BodyDefaultLight>Ontdek hoe je met de GoodShift Giftcard het verschil maakt.</BodyDefaultLight>
          <LinkAsButton href={"/giftcard"} text={"Bekijk de mogelijkheden"} type="secondary" className="mb-14" />
        </>
      }
      image={{
        url: "/goodshift/img/home/giftcard.jpg",
        alt: "Goodshit giftcard image",
        side: "right",
        breakBounds: false,
      }}
    />
  )
}
